// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".base-popup-wrap__title{margin-bottom:24px;padding-right:10px;font-family:var(--1vli1g5);font-size:var(--co857n);font-weight:var(--yy6lk6);text-transform:var(--5lavw2)}.base-popup-wrap__subtitle{margin-bottom:8px;font-size:16px;line-height:24px}.base-popup-wrap__subtitle.is-success{color:var(--z03ht2)}.base-popup-wrap__content{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
